var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-title-header", {
        staticClass: "scroll-effect",
        class: { "is-active": _vm.isLoaded },
        attrs: { "category-slug": _vm.categorySlug },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "left-col-container" }, [
        _c(
          "div",
          {
            staticClass: "container scroll-effect",
            class: { "is-active": _vm.isLoaded },
          },
          [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("div", { staticClass: "col-sm-9 left-col-text" }, [
                  _c("h1", [_vm._v(_vm._s(_vm.titleText))]),
                  _vm._v(" "),
                  _vm.posts.length > 0
                    ? _c("div", { staticClass: "panel panel-default" }, [
                        _c("div", { staticClass: "table-responsive" }, [
                          _c("table", { staticClass: "table table-striped" }, [
                            _c(
                              "tbody",
                              { attrs: { id: "articles" } },
                              _vm._l(_vm.posts, function (post) {
                                return _c("tr", { key: post.postId }, [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dateFormat(post.publishAt, "Y/M/D")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { attrs: { width: "7%" } },
                                    [
                                      _vm.checkEmpty(post.categorySlug) ===
                                      false
                                        ? _c("router-link", {
                                            class: _vm.getCateLabelClass(
                                              post.categorySlug
                                            ),
                                            attrs: {
                                              to: {
                                                path: "/posts/",
                                                query: {
                                                  category: post.categorySlug,
                                                },
                                              },
                                            },
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.getCategoryLabel(
                                                  post.categorySlug
                                                )
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              path: "/posts/",
                                              query: { id: post.slug },
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(post.title))]
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.hasNext
                          ? _c("nav", {}, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn-link btn-lg btn-block u-fs-16",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.fetchPosts()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                もっと見る\n              "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm.isLoading === false
                    ? _c("div", { staticClass: "panel panel-default" }, [
                        _c("p", [_vm._v("指定のお知らせはありません")]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.categorySlug === "entry"
                    ? _c("div", { staticClass: "mt-8" }, [
                        _c("iframe", {
                          staticStyle: {
                            width: "100%",
                            border: "none",
                            height: "250px",
                          },
                          attrs: {
                            src: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTcMxzMcRJLAwTubrjaNqymvy4PoZ4pkbxRp-rwe2rWtYbxZs77mOPEZ-L-3cEariFHl7dOvETfkUSi/pubhtml?widget=true&headers=false",
                          },
                        }),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("side-menu", {
                  staticClass: "js-scroll-effect scroll-effect",
                  attrs: {
                    "category-slug": _vm.categorySlug,
                    "data-start-pos": "200",
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }